import { CSVUpload } from 'pages/CSVUpload/CSVUpload'

export default CSVUpload
